import { Component } from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RotateCcw, ArrowLeft } from 'lucide-react';

export default class EditorErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Ignore benign DOM errors from React + Tiptap conflict
    if (error?.message?.includes('removeChild') || error?.message?.includes('insertBefore') || error?.message?.includes('not a child')) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Silently ignore DOM manipulation errors (React + Tiptap race condition)
    if (error?.message?.includes('removeChild') || error?.message?.includes('insertBefore') || error?.message?.includes('not a child')) {
      console.warn('[EditorErrorBoundary] Benign DOM error ignored:', error.message);
      this.setState({ hasError: false, error: null });
      return;
    }
    console.error('[EditorErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
          <AlertTriangle className="h-16 w-16 text-orange-500/70 mb-4" />
          <h2 className="text-2xl font-semibold mb-2">
            L'éditeur n'a pas pu se charger
          </h2>
          <p className="text-muted-foreground mb-2 max-w-md">
            Une erreur est survenue lors du chargement de l'éditeur d'articles.
          </p>
          <p className="text-xs text-muted-foreground mb-8 font-mono max-w-lg truncate">
            {this.state.error?.message}
          </p>
          <div className="flex gap-3">
            <Button
              variant="outline"
              className="gap-2"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.reload();
              }}
            >
              <RotateCcw className="h-4 w-4" /> Recharger
            </Button>
            <Button
              className="gap-2"
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/dashboard';
              }}
            >
              <ArrowLeft className="h-4 w-4" /> Dashboard
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
